import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { CLAIMED_REWARDS } from "../../../../../../types/Types";
import { MODALS } from "../../../DashboardContent";
import { SCREENS } from "../HomeTab";

type Props = {
  claimedRewards?: CLAIMED_REWARDS[];
  toggleScreen: (screen: string) => void;
  toggleOpenClose: (modal: string, data: any) => void;
};

const ActiveRewardsContent: FunctionComponent<Props> = ({
  claimedRewards,
  toggleScreen,
  toggleOpenClose,
}) => {
  console.log(claimedRewards);
  const { t } = useTranslation();

  return (
    <div className="nav-tab__home-container--two">
      <div className="par-ecom-widget__active-reward">
        <div className="par-ecom-widget__active-reward-title">
          <span
            className="par-ecom-widget__active-reward-title-icon"
            onClick={() => toggleScreen(SCREENS["HOME"])}
          >
            <svg
              width="6"
              height="12"
              viewBox="0 0 6 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.851447 11.9984C0.652855 11.9988 0.460396 11.9292 0.30748 11.8017C0.13366 11.6567 0.0243216 11.4481 0.0035921 11.2219C-0.0171374 10.9956 0.0524454 10.7704 0.196987 10.5958L4.00476 6.01173L0.332979 1.41906C0.190382 1.24237 0.123663 1.01578 0.147592 0.789442C0.17152 0.563109 0.284124 0.355709 0.460471 0.213163C0.638252 0.0557642 0.873229 -0.0198705 1.10879 0.00448179C1.34435 0.028834 1.55913 0.150965 1.7014 0.34145L5.80665 5.47292C6.06445 5.78851 6.06445 6.2435 5.80665 6.55909L1.5569 11.6906C1.38397 11.9005 1.12193 12.0148 0.851447 11.9984Z"
                fill="#2196f3"
              />
            </svg>
          </span>
          <h2>{t("your_active_rewards")}</h2>
        </div>
        <ul className="par-ecom-widget__list">
          {claimedRewards?.map((claimedReward, index) => {
            return (
              <li className="par-ecom-widget__list-item par-ecom-widget__active-reward-discount accent-color">
                <span className="par-ecom-widget__list-leading-icon">
                  <svg
                    width="28"
                    height="27"
                    viewBox="0 0 28 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M20.8002 25.8533C20.99 25.9505 21.2003 26.0008 21.4135 25.9999C21.7081 26.0135 21.9988 25.9291 22.2402 25.7599C22.6626 25.4574 22.8707 24.937 22.7735 24.4266L21.4402 16.9199L26.9335 11.5866C27.2828 11.2381 27.411 10.7252 27.2669 10.2533C27.1092 9.76984 26.6903 9.41817 26.1869 9.34661L18.5869 8.23995L15.2002 1.41328C14.9774 0.953292 14.5113 0.661133 14.0002 0.661133C13.4891 0.661133 13.023 0.953292 12.8002 1.41328L9.45354 8.25328L1.85354 9.35995C1.3501 9.4315 0.931198 9.78318 0.773539 10.2666C0.629385 10.7385 0.757614 11.2514 1.10687 11.5999L6.60021 16.9333L5.26687 24.4399C5.17785 24.9411 5.38189 25.4492 5.79278 25.7495C6.20367 26.0499 6.74972 26.0902 7.20021 25.8533L14.0002 22.2933L20.8002 25.8533ZM14.6135 19.6133C14.4254 19.5118 14.2139 19.4612 14.0002 19.4666C13.7773 19.4223 13.5465 19.4408 13.3335 19.5199L8.30687 22.1866L9.26687 16.6399C9.3425 16.2048 9.1977 15.7604 8.88021 15.4533L4.88021 11.5466L10.4802 10.7199C10.9111 10.6576 11.2844 10.3888 11.4802 9.99995L14.0002 4.99995L16.5202 9.99995C16.6988 10.3854 17.0504 10.6628 17.4669 10.7466L23.0669 11.5733L19.0669 15.4799C18.7494 15.787 18.6046 16.2314 18.6802 16.6666L19.6402 22.2799L14.6135 19.6133Z"
                      fill="#74CAFF"
                    />
                  </svg>
                </span>
                <div className="par-ecom-widget__list-content">
                  <span className="par-ecom-widget__list-label">
                    {claimedReward.reward_name}
                  </span>
                  <span className="par-ecom-widget__list-help-text">
                    {`${claimedReward.redeemed_points} ${t("points")}`}
                  </span>
                </div>
                <span
                  className="par-ecom-widget__list-trailing-icon"
                  onClick={() =>
                    toggleOpenClose(MODALS["ACTIVEREWARDSMODAL"], claimedReward)
                  }
                >
                  <svg
                    width="6"
                    height="12"
                    viewBox="0 0 6 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.851447 11.9984C0.652855 11.9988 0.460396 11.9292 0.30748 11.8017C0.13366 11.6567 0.0243216 11.4481 0.0035921 11.2219C-0.0171374 10.9956 0.0524454 10.7704 0.196987 10.5958L4.00476 6.01173L0.332979 1.41906C0.190382 1.24237 0.123663 1.01578 0.147592 0.789442C0.17152 0.563109 0.284124 0.355709 0.460471 0.213163C0.638252 0.0557642 0.873229 -0.0198705 1.10879 0.00448179C1.34435 0.028834 1.55913 0.150965 1.7014 0.34145L5.80665 5.47292C6.06445 5.78851 6.06445 6.2435 5.80665 6.55909L1.5569 11.6906C1.38397 11.9005 1.12193 12.0148 0.851447 11.9984Z"
                      fill="#2196f3"
                    />
                  </svg>
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ActiveRewardsContent;
